import { createContext, useState, useEffect, useContext } from "react";
import { debounce } from "../utils/async";
import { CurrentUser } from './CurrentUser';

export const currentSearch = createContext()

export const END_POINTS = {
    search: 'posts/search',
    forums: 'posts/forums',
    forum: 'posts/topics/',
}

const DEFAULT_QUERY = {
    page: 1,
    size: 25,
    term: '',
    sortBy: 'post_time',
    sortDir: 'DESC',
    from: null,
    to: null,
    mode: 'search',
    slug: '',
    col: 'all'
}

const DEFAULT_RESULT = {
    rows: [],
    meta: {
        page: 1,
        size: 25,
        total: 0
    }
};
const fetchData = async (query) => {
    const params = new URLSearchParams(query);
    const endpoint = `${END_POINTS[query?.mode]}${query?.slug}`;
    try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}${endpoint}?${params.toString()}`)
        if (response.status === 200) {
            return await response.json();
        }
    } catch (e) {
        return DEFAULT_RESULT
    }
}

const debouncedFetch = debounce(this, fetchData, 500)

function SearchProvider({ children }) {
    const isIndexRoute = window.location.pathname === '/';
    const { isLoggedIn } = useContext(CurrentUser);
    const [query, setQuery] = useState(DEFAULT_QUERY);
    const [results, setResults] = useState(DEFAULT_RESULT);
    const [isLoading, setIsLoading] = useState(false);

    const asyncFetch = async () => {
        setIsLoading(true);
        const resultSet = await debouncedFetch(query);
        setResults(resultSet || DEFAULT_RESULT)
        setIsLoading(false);
    }

    useEffect(() => {
        if (isLoggedIn && !isIndexRoute) {
            asyncFetch();
        }
        // eslint-disable-next-line
    }, [query, isLoggedIn])

    const clearSearch = () => {
        setQuery(DEFAULT_QUERY);
    }

    const nextPage = (e) => {
        e.preventDefault();
        const { meta: { page, pages } } = results;
        const nextPage = parseInt(page) + 1;
        if (nextPage <= pages) {
            setQuery({ ...query, page: nextPage })
        }

    }
    const prevPage = (e) => {
        e.preventDefault();
        const { page } = query;
        const prevPage = parseInt(page) - 1;
        if (prevPage > 0) {
            setQuery({ ...query, page: prevPage })
        }
    }

    const firstPage = (e) => {
        e.preventDefault();
        setQuery({ ...query, page: 1 })
    }
    const lastPage = (e) => {
        e.preventDefault();
        const { meta: { pages } } = results;
        setQuery({ ...query, page: pages })
    }

    const setPage = (pageNumber) => {
        const { meta: { pages } } = results;
        if (pageNumber && pageNumber <= pages) {
            setQuery({ ...query, page: pageNumber })
        }
    }

    const providerValue = {
        isLoading,
        query,
        setQuery,
        results,
        setResults,
        nextPage,
        prevPage,
        firstPage,
        lastPage,
        setPage,
        clearSearch
    };
    return (
        <currentSearch.Provider value={providerValue}>
            {children}
        </currentSearch.Provider>
    )
}

export default SearchProvider